function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeKel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6.97mm",
    height: "7.0009mm",
    viewBox: "0 0 6.97 7.0009",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-77.933 -113.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.77 118.71v-4.201c0-.53065-.42743-.95808-.95808-.95808h-4.7889c-.53065 0-.95808.42743-.95808.95808v4.201",
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      strokeDashoffset: 11.411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 81.417862,
    y: 120.40054,
    style: {
      fill: "none",
      fontFamily: "Univers",
      fontSize: "1.5524px",
      letterSpacing: 0,
      lineHeight: 0,
      strokeWidth: ".0089677px",
      stroke: "#000000",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81.417862,
    y: 120.40054,
    style: {
      fill: "#000000",
      fontFamily: "Figtree",
      fontWeight: 500,
      strokeWidth: ".0089677px",
      stroke: "none",
      textAlign: "center",
      textAnchor: "middle"
    }
  }, "KEL")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.82352 0 0 .82587 7.3384 20.881)",
    style: {
      strokeWidth: 1.2126
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.955 117.05 1.1075-1.1076-.000365-.00036a1.5663 1.5663 0 00.000363-2.2147 1.5663 1.5663 0 00-2.2151 0 1.5663 1.5663 0 002e-6 2.2151z",
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      strokeDashoffset: 11.411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.32083,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.955,
    cy: 114.84,
    r: 0.38874,
    style: {
      fillRule: "evenodd",
      fill: "#000000",
      paintOrder: "stroke markers fill"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeKel);
export default __webpack_public_path__ + "static/media/icon_type_kel.a7a1012e1476ecd69504a81298fb5f24.svg";
export { ForwardRef as ReactComponent };